import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow';
import viewInviteList from "./components/viewInviteList.vue";
import addInviteItem from "./components/addInviteItem.vue";
import { vipRechargeUser, vipCall } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage, serchSelect, tabulation } from "@/mixins/index";
export default {
  name: "communication",
  mixins: [gmToolNew, gmToolNewPage, serchSelect, tabulation],
  components: {
    viewInviteList: viewInviteList,
    addInviteItem: addInviteItem
  },
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      exportLoading: false,
      paramsData: {
        page: 1,
        state: '',
        vip_time: '',
        loss_days: '',
        total_amount: ''
      },
      total: 0,
      date: [],
      options: [],
      stateType: [{
        value: 1,
        label: this.$t('recalled')
      }, {
        value: 2,
        label: this.$t('notRecalled')
      }]
    };
  },
  created: function created() {},
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.paramsData.page = e;
                _this.paramsData.vip_start_time = _this.date && _this.date[0];
                _this.paramsData.vip_end_time = _this.date && _this.date[1];
                _this.reqLoading = true;
                vipRechargeUser(_objectSpread(_objectSpread({}, _this.paramsData), {}, {
                  game_id: _this.rawData.game_id
                }, _this.defaultData())).then(function (res) {
                  if (res.code == 200) {
                    _this.tableData = res.data.data;

                    _this.tableData.forEach(function (item) {
                      item.total_amount = _this.$utils.conversion(item.total_amount).toFixed(3);

                      var foundData = _this.serverListYJ.find(function (b) {
                        return b.serverID == item.server_id;
                      });

                      item.server_name = foundData ? foundData.serverName : '/';
                    });

                    _this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    addInviteItemData: function addInviteItemData(row) {
      var _this2 = this;

      this.$confirm(this.$t('confirmInvite'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$refs.addInviteItem.init(row);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    },
    vipCallBack: function vipCallBack(row) {
      var _this3 = this;

      this.$confirm(this.$t('confirmOperation'), this.$t('prompt'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var vip_state, user_id_str, role_id, server_id, params;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                vip_state = row.vip_state, user_id_str = row.user_id_str, role_id = row.role_id, server_id = row.server_id;
                params = {
                  state: vip_state == 2 ? 1 : 2,
                  user_id: user_id_str,
                  role_id: role_id,
                  server_id: server_id,
                  game_id: _this3.rawData.game_id
                };
                vipCall(params).then(function (res) {
                  if (res.code == 200) {
                    _this3.getList(_this3.currentPage);
                  }
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.options = val;
    },
    batchInvite: function batchInvite() {
      this.$refs.addInviteItem.init(this.options);
    },
    exportdata: function exportdata() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var columns;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                columns = [{
                  label: _this4.$t('game'),
                  prop: 'game'
                }, {
                  label: _this4.$t('channel'),
                  prop: 'channel'
                }, {
                  label: _this4.$t('packageName'),
                  prop: 'pkg'
                }, {
                  label: _this4.$t('adChannel'),
                  prop: 'ad_channel'
                }, {
                  label: _this4.$t('adPosition'),
                  prop: 'ad_placement'
                }, {
                  label: _this4.$t('serverName'),
                  prop: 'server_name'
                }, {
                  label: _this4.$t('userId'),
                  prop: 'user_id_str'
                }, {
                  label: _this4.$t('roleId'),
                  prop: 'role_id'
                }, {
                  label: _this4.$t('roleName'),
                  prop: 'role_name'
                }, {
                  label: _this4.$t('phoneNumber'),
                  prop: 'phone'
                }, {
                  label: _this4.$t('totalRechargeAmount'),
                  prop: 'total_amount'
                }, {
                  label: _this4.$t('lastLoginTime'),
                  prop: 'last_login_time'
                }, {
                  label: _this4.$t('lastRechargeTime'),
                  prop: 'last_recharge_time'
                }, {
                  label: _this4.$t('lastInviteTime'),
                  prop: 'last_send_time'
                }, {
                  label: _this4.$t('isLost'),
                  prop: 'loss'
                }];
                _this4.exportLoading = true;
                _context5.next = 4;
                return vipRechargeUser(_objectSpread(_objectSpread({}, _this4.paramsData), {}, {
                  page_size: -1,
                  game_id: _this4.rawData.game_id
                })).then(function (res) {
                  if (res.code == 200) {
                    var list = res.data.data;
                    list.forEach(function (item) {
                      item.total_amount = _this4.$utils.conversion(item.total_amount).toFixed(3);

                      var foundData = _this4.serverListYJ.find(function (b) {
                        return b.serverID == item.server_id;
                      });

                      item.server_name = foundData ? foundData.serverName : '/';
                    });

                    _this4.$export.excel({
                      columns: columns,
                      data: list,
                      title: _this4.$route.meta.title
                    });
                  }
                }).finally(function () {
                  _this4.exportLoading = false;
                });

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};